module.exports = __webpack_public_path__ + "static/media/blub_glow.ddb83c2d.png";